<template>
  <div class="service-time-selector">
    <el-date-picker
      size="mini"
      v-model="sourceObject.date"
      :picker-options="todayAfter"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择日期"
      :clearable="false"
    ></el-date-picker>
    <el-select v-model="sourceObject.time" size="mini" placeholder="请选择时段">
      <el-option v-for="item in times" :key="item" :label="item" :value="item"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    sourceObject: {
      required: true
    },
    times: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      todayAfter: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
    }
  }
}
</script>

<style lang="stylus">
.service-time-selector {
  display: flex;

  >div {
    width: 0;
    min-width: 0;
    flex: 1;

    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
